import TkButton from "../../../components/atoms/TkButton";

function handleList(list: any, handleDelete: any, handleFix: any) {
  const listData: any = [];
  list.forEach((item: any) => {
    const data = [
      {
        children: item.userId,
        forSort: item.userId,
        align: "left",
      },
      {
        children: item.name,
        forSort: item.name,
        align: "left",
      },
      {
        children: <TkButton onClick={() => handleDelete(item)}>削除</TkButton>,
        align: "center",
      },
      {
        children: item.email,
        forSort: item.email,
        align: "left",
      },
      {
        children: (
          <TkButton
            onClick={() => {
              handleFix(item);
            }}
          >
            修正
          </TkButton>
        ),
        align: "center",
      },
    ];
    listData.push(data);
  });
  return listData;
}
export { handleList };
